// Mirrors the mockup's actual data model (docs/prime-moq-mockup-v3.html,
// newRule()/refreshEditor()): a rule only ever has ONE of three underlying
// "Limit type" buckets — qty / value / weight — each covering several
// optional fields at once (qty covers min+max+multiple together). The 6-card
// SelectRuleType.js picker is just a set of starting presets (see
// initialRuleValues.js), not 6 distinct stored types: minqty/maxqty/mult/
// repurchase all land in the 'qty' bucket, matching newRule(kind)'s own
// base.type default. `RuleType` on the backend keeps its original 6 values
// (min_qty/max_qty/multiple/value/weight/repurchase) for backward
// compatibility — no schema/migration change — this just governs which
// bucket a given `rule.type` value displays as.
export function getRuleTypeBucket(type) {
  if (type === 'value') return 'value';
  if (type === 'weight') return 'weight';
  return 'qty'; // min_qty, max_qty, multiple, repurchase (legacy), anything else
}

// The value written back to rule.type when the "Limit type" dropdown is
// changed — one canonical representative per bucket.
export const CANONICAL_TYPE_FOR_BUCKET = {
  qty: 'min_qty',
  value: 'value',
  weight: 'weight',
};
